export default __webpack_public_path__ + "static/media/Hip.bd2dafca.png";